const billing = {
	invoices: {
		invoice_dialog: {
			actions: {
				download: "Download",
				pay: "Pay",
			},
			invoice_date: "Invoice Date",
			pay_before: "Pay Before",
			status: "Status",
			table: {
				date: "Date",
				description: "Description",
				price: "Price excl. VAT",
				quantity: "Quantity",
				total_row: {
					price_with_vat: "Price incl. VAT €",
					price_without_vat: "Price excl. VAT €",
					vat_percentage: "21% VAT €",
				},
			},
		},
		title: "Invoices",
	},
	orders: {
		table: {
			company: "Company",
			debtor_code: "Debtor Code",
			free: "Free",
			order_date: "Date Created",
			order_label: "Label",
			order_number: "Order Number",
			order_status: "Order Status",
			order_type: {
				dadup: "daDup",
				domain: "Domains",
				label: "Products",
				pbs: "PBS",
				pbs_free: "PBS free",
				pbs_sync: "PBS sync",
				qemu: "VPS",
			},
			other: "Other",
			reset: "Reset",
			search: "Search",
			status: {
				active: "Active",
				cancellation_pending: "Cancellation in progress",
				cancelled: "Cancelled",
				completed: "Completed",
				ended: "Ended",
				failed: "Failed",
				label: "Statuses",
				pending: "Pending",
				replaced: "Replaced",
			},
			sub_row: {
				alert_description:
					"This service is billed in arrears. Click on view on the right for your current usage.",
				expired_at: "Expired at",
				order_done_by: "Order done by",
				order_purchase_number: "Purchase order number",
				price: "Price excl. VAT",
				product: "Product",
				quantity: "Quantity",
				replaced_by_order: "Replaced by order",
				replaces_order: "Replaces Order",
				title: "Order",
				unit: {
					mb: "MB",
					unit_month: "month",
					x: "X",
				},
			},
			total_price: "Total Price",
		},
	},
};

export default billing;
